export default "__VITE_ASSET__BrpkUciy__"